/**
 * Phase 350 — Dedicated "Building Management → Settings" page.
 *
 * Splits the Settings hub out of the Manage Buildings list view so the
 * Settings area feels like a separate management surface. Re-uses the
 * existing BuildingsSettingsPanel in `pageMode` so we keep one source of
 * truth for the category list and inline section bodies.
 */
import React from 'react';
import Layout from '../components/Layout';
import BuildingsSettingsPanel from '../components/BuildingsSettingsPanel';
import { Gear, ArrowLeft } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function BuildingSettings() {
  const { isAdmin } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-6" data-testid="building-settings-page">
        <button
          onClick={() => navigate('/buildings')}
          className="flex items-center gap-1.5 text-sm text-zinc-400 hover:text-zinc-700 mb-4"
          data-testid="building-settings-back-to-buildings"
        >
          <ArrowLeft size={14} />
          <span>{t('manageBuildings') || 'Manage Buildings'}</span>
        </button>
        <div className="flex items-center gap-2 mb-4">
          <Gear size={20} weight="fill" className="text-zinc-700" />
          <div>
            <h1 className="text-xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('settings') || 'Settings'}
            </h1>
            <p className="text-xs text-zinc-500">
              Κοινά settings που ισχύουν σε όλες τις πολυκατοικίες
            </p>
          </div>
        </div>
        <BuildingsSettingsPanel isAdmin={isAdmin} pageMode />
      </div>
    </Layout>
  );
}
